import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "../../factories/tab-page";
import BaoDialog from "../../factories/bao-dialog";
import BaoRouter from "../../services/bao-router";
import BaoMenu from "../../services/bao-menu";
import ShiftScheduleViewModel from "../../view-models/team-schedule";
import SearchPaging from "../../factories/search-paging";
import { TicketTypeCategoriesConstants } from "./../constants/ticket-type-categories-constants"

/**
     *Opens a Dialog Holiday assigment at the Teamschduele
     *the Dialog is activated by the Systemsetting ShowDetailsInDialog_{Mandator-ID}
     */
class ShiftAbsenceDialog extends SearchPaging {

    dialog: BaoDialog;

    constructor(tabPage, parent, ticketApproveStateApproved, ticketApproveStateNotApproved, ticketApproveStateUnedited, ticketStatusClosed, ticketStatusWaitForApproval) {
        super(tabPage);
        this.Parent = parent;
        //Get Ticket states
        this.TicketApproveStateApproved(ko.unwrap(ticketApproveStateApproved));
        this.TicketApproveStateNotApproved(ko.unwrap(ticketApproveStateNotApproved));
        this.TicketApproveStateUnedited(ko.unwrap(ticketApproveStateUnedited));
        this.TicketStatusClosed(ko.unwrap(ticketStatusClosed));
        this.TicketStatusWaitForApproval(ko.unwrap(ticketStatusWaitForApproval));

        $.extend(this);
        this.AlertCss = ko.computed(() => {
            if (this.TicketApproveStateId() == this.TicketApproveStateApproved()) {
                return "alert-success";
            } else if (this.TicketApproveStateId() == this.TicketApproveStateNotApproved()) {
                return "alert-danger";
            }
            return "alert-info";
        });
        //Urlaubsart dropdown:               
        this.TicketTypeId.subscribe(() => {
            this.GetTicketTypeCategory();            
            if (this.InitInProgress == false) {
                this.IsApprovalAllowed();
            }
        });

        this.HolidayDaysDropdown.subscribe((item) => {
            if (this.InitInProgress == false && this.HolidayTypeAsString() == "1") {
                if (item != undefined) {
                    this.HolidayDaysJs(item);
                }
            }
        });
        this.subscribe(this.ApprovalAllowed, (newValue) => {
            if (newValue != null) {
                BaoMenu.permissionEnable({
                    ActionKey: "ActionHolidayApprove", Enabled: !this.IsReadonly() && this.ApprovalAllowed() && (this.TicketApproveStateId() == null || this.TicketApproveStateId() == this.TicketApproveStateUnedited()), Context: this.TabPage.Context()
                });
            }
        });

        this.HolidayDaysJs.subscribe((item) => {
            this.HolidayDaysDropdown(item);
        });

        this.HolidayTypeAsString.subscribe((newval) => {
            if (this.InitInProgress == false) {
                //this.FromDateJs();
                this.ToDateJs("");
                if (newval === "0") { // when the field needs to be calculated
                    this.HolidayDays(null);
                    this.HolidayDaysJs(null);
                } else {
                    this.HolidayDays(1);
                    this.HolidayDaysJs(1);
                    this.HolidayDaysDropdown("1");
                }
            }
        });

        this.FromDateJs.subscribe(() => {
            this.CalculateHolidayDays();
        });

        this.ToDateJs.subscribe((ite) => {
            if (this.ignoreSubscribes) { return; }
            this.CalculateHolidayDays();
        });

        //AktionButton:
        this.TabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case "ActionHolidayApprove":
                        this.Approve();
                        break;
                    case "ActionHolidayReOpen":
                        this.ReopenHoliday();
                        break;
                }
            }
        }));
    }
    Bao = Bao;

    Parent: any;
    InitInProgress = true;
    ignoreSubscribes = false;
    AlertCss: KnockoutComputed<string>;
    _deleteMessage = Bao.Session.GetMessage("msgDeleteTicket");
    _saveMessage = Bao.Session.GetMessage("msgSaveCheck");
    _msgYes = Bao.Session.GetMessage("msgYes");
    _msgNo = Bao.Session.GetMessage("msgNo");
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");
    IsNew = ko.observable();
    HolidayHideIsSubstituteClarified = ko.observable(false);
    TicketTypes = ko.observableArray([]);
    Solution = ko.observable();
    Problem = ko.observable();
    AffectedPersonSupervisor = ko.observable();
    TicketTypeName = ko.observable();
    AffectedPersonId = ko.observable();
    OwnerPersonName = ko.observable();
    AffectedPersonName = ko.observable();
    AffectedPersonStateName = ko.observable();
    HolidayDays = ko.observable();
    HolidayDaysDropdown = ko.observable("1");
    IsSubstituteClarified = ko.observable();
    HolidayTypeAsString = ko.observable();
    TicketTypeId = ko.observable();
    IsPersonalDepartmentSuperior = ko.observable<boolean>(true);
    FromDateJs = ko.observable();
    ToDateJs = ko.observable();
    TicketApproveStateId = ko.observable();
    TicketLocked = ko.observable(false);
    IsReadonly = ko.observable(false);
    HolidayDaysJs = ko.observable<any>();
    //TicketStatusClosed = "82eb2417-2708-4de7-8117-d1a52775b128";
    TicketApproveStateApproved: KnockoutObservable<string> = ko.observable('');
    TicketApproveStateNotApproved: KnockoutObservable<string> = ko.observable('');
    TicketApproveStateUnedited: KnockoutObservable<string> = ko.observable('');
    TicketStatusClosed: KnockoutObservable<string> = ko.observable('');
    TicketStatusWaitForApproval: KnockoutObservable<string> = ko.observable('');

    OwnerPersonId: KnockoutObservable<string>;
    ToDate: KnockoutObservable<string>;
    FromDate: KnockoutObservable<string>;
    TicketId: KnockoutObservable<string>;
    SaveAllowed: KnockoutObservable<boolean>;
    LockGuid: KnockoutObservable<string>;
    TicketStatusId: KnockoutObservable<string>;

    ApprovalAllowed = ko.observable();



    AffectedPersonChanged = (model) => {
        if (this.InitInProgress == false) {
            if (model != null) {
                this.AffectedPersonStateName(model.StateName);
                this.OwnerPersonName(model.SupervisorPersonFullName);
                this.OwnerPersonId(model.SupervisorPersonId);
                this.FromDateJs("");
                this.ToDateJs("");
                this.HolidayDays(0);
            }
            else {
                this.AffectedPersonStateName("");
                this.OwnerPersonName("");
                this.OwnerPersonId(null);
                this.FromDateJs("");
                this.ToDateJs("");
                this.HolidayDays(0);
            }

            this.IsApprovalAllowed();
        }
    };


    CalculateHolidayDays() {
        if (this.InitInProgress == false) {
            if (this.FromDateJs() != null && this.FromDateJs() != "" && this.ToDateJs() != null && this.ToDateJs() != "") {
                return Bao.post("Holiday/GetHolidayDays", JSON.stringify({
                    FromDay: this.FromDateJs(),
                    ToDay: this.ToDateJs(),
                    PersonId: this.AffectedPersonId()
                }), (value) => {
                    this.HolidayDaysJs(0);
                    this.HolidayDaysJs(value);
                });
            }
        }
        return $.Deferred<any>().resolve().promise();
    };

    CompleteCheck(): any {
        let def = $.Deferred<boolean>();

        var isComplete = true;
        var isValid = true;

        if (this.AffectedPersonId() == null) {
            isComplete = false;
        }

        if (this.HolidayTypeAsString() == "1" || this.HolidayTypeAsString() == "2") {
            let tmpState_ignoreSubscribes = this.ignoreSubscribes;
            this.ignoreSubscribes = true;
            this.ToDateJs(this.FromDateJs());
            this.ignoreSubscribes = tmpState_ignoreSubscribes;
        }
        if (this.HolidayTypeAsString() == "0") {
            if (this.FromDateJs() == null || this.FromDateJs() == "" || this.ToDateJs() == null || this.ToDateJs() == "") {
                isComplete = false;
            } else {
                if (this.FromDateJs() > this.ToDateJs()) {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidayDateNotValid"), "info");
                    def.resolve(false);
                    return;
                }
            }
        }
        if (this.HolidayTypeAsString() == "2") {
            if (Bao.Utils.String.IsNullOrWhitespace("" + this.HolidayDaysJs())) {
                isComplete = false;
            } else {
                var x = parseInt(this.HolidayDaysJs())
                if (isNaN(x) || x <= 0) {
                    isComplete = false;
                }
            }
        }
        if (this.FromDateJs() == "") {
            isComplete = false;
        }
        if (!this.HolidayHideIsSubstituteClarified()) {
            if (this.IsSubstituteClarified() == null || this.IsSubstituteClarified() == false) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidaySubstituteNotClarified"), "info");
                def.resolve(false);
            }
        }

        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(false);
        }
        else {
            this.CheckConflictsWithOtherHolidayRequests().then((result) => {
                def.resolve(result);
            });
        }

        return def.promise();

    };

    /**
     * returns true, if everything is okay, false if conflicts found. 
     * Shows a Message, if conflicts found and a message was returned from server
     */
    CheckConflictsWithOtherHolidayRequests(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        Bao.post("Holiday/HasHolidayRequestConflicts", JSON.stringify({ model: this.MinimizeEntity() }))
            .then((serverResult: { Result: boolean, Message: string }) => {
                if (serverResult.Result && !Bao.Utils.String.IsNullOrEmpty(serverResult.Message)) {
                    new BaoDialog(Bao.Session.ApplicationName, serverResult.Message, "info");
                }
                def.resolve(!serverResult.Result);
            });
        return def.promise();
    };

    TicketStatusWaitsForApproval = this.TicketStatusWaitForApproval();

    ApprovalRequired = ko.observable();

    IsApprovalAllowed() {
        return Bao.post("Holiday/IsApprovalAllowed", JSON.stringify({
            requesterPersonId: ko.map.toJS(this.AffectedPersonId()),
            ticketTypeId: ko.map.toJS(this.TicketTypeId())
        }), (result) => {
            this.ApprovalAllowed(result);
        });
    };

    /**
     * Get TicketTypeCategoryId for selected TicketTypeId and set IsPersonalDepartmentSuperior()
     */
    GetTicketTypeCategory() {
        return Bao.post("Holiday/GetTicketTypeCategory", JSON.stringify({
            ticketTypeId: ko.map.toJS(this.TicketTypeId())
        }), (result) => {
            this.IsPersonalDepartmentSuperior(result === TicketTypeCategoriesConstants.HOLIDAY_REQUEST);            
        });
    }

    RemoveIsClicked() {
        var deleteIsTrue = this.BeforeDelete();
        if (deleteIsTrue) {

            //this.Parent.RefreshSchedule();
        }
    }

    /**
     * Approve/Reject the request on approve button click
     */
    OnApproveButtonClick() {
        this.Approve();
    }
    /**
     * Check whether the approve button should be enabled
     */
    CanUseApproveButton() {
        return !this.IsNew() &&
            !this.IsReadonly() &&
            this.ApprovalAllowed() &&
            (this.TicketApproveStateId() == null || this.TicketApproveStateId() == this.TicketApproveStateUnedited())
    }

    Approve() {
        $.when(this.CompleteCheck()).then((completeResult) => {

            if (completeResult != true) {
                return;
            }
            var approveDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidayApproveQuestion"));
            approveDialog.Width("600px");
            approveDialog.Buttons([{
                Title: Bao.Session.GetMessage("msgApprove"),
                Click: () => {
                    approveDialog.DialogResult(true);
                    approveDialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            },
            {
                Title: Bao.Session.GetMessage("msgReject"),
                Click: () => {
                    approveDialog.DialogResult(false);
                    approveDialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    approveDialog.DialogResult(null);
                    approveDialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            }
            ]);

            this.subscribe(approveDialog.DialogResult, (approveResult) => {
                if (approveResult === true || approveResult === false) {
                    this.Save().then(() => {
                        var approveStateId = this.TicketApproveStateApproved();
                        if (approveResult == false) {
                            approveStateId = this.TicketApproveStateNotApproved();
                        }
                        this.SetApprove(approveStateId);
                    });
                }
            });

            approveDialog.Open();
        });
    };

    SetApprove(approveStateId) {
        let def = $.Deferred();
        this.TabPage.IsLoading(true);
        Bao.post("Holiday/Approve", JSON.stringify({
            id: this.TicketId(),
            approveStateId: approveStateId
        }), (result) => {
            if (result == true) {
                BaoMenu.permissionEnable({ ActionKey: "ActionHolidayApprove", Enabled: false, Context: this.TabPage.Context() });
                this.PerformRefresh().then(() => {
                    def.resolve(true);

                });
            } else {
                def.resolve(true);
            }
        });
        return def.promise();
    };

    ReopenHoliday() {
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgReopenHolidayQuestion"), "question");
        questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                Bao.post("Holiday/ReopenTicket", JSON.stringify({ ticketId: this.TicketId() }), (reopenResult) => {
                    if (reopenResult.Result == true) {
                        this.PerformRefresh();
                    }
                });
            }
        });
    };

    TicketUnlock() {
        var q = $.Deferred();
        if (this.TicketId() != null) {
            return Bao.post("Ticket/UnlockTicket", JSON.stringify({ id: this.TicketId(), lockGuid: this.LockGuid() }));
        } else {
            q.resolve();
        }
        return q.promise();
    };

    BeforeClose = (fn: any) => {
        if (this.TabPage.IsDirty() == true && this.SaveAllowed() === true) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, this._saveMessage, "question");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    $.when(this.CompleteCheck()).then((completeResult) => {
                        this.TabPage.IsLoading(true);
                        if (completeResult == true) {
                            $.when(this.Save()).done(() => {
                                $.when(this.TicketUnlock()).then(() => {
                                    this.TabPage.IsLoading(false);
                                    this.DestroyObject();
                                    fn();
                                });
                            });
                        }
                    });
                } else if (result === false) {
                    this.TabPage.IsLoading(true);
                    $.when(this.TicketUnlock()).then(() => {
                        this.TabPage.IsLoading(false);
                        this.DestroyObject();
                        fn();
                    });
                }
            });
        } else {
            this.TicketUnlock();
            this.DestroyObject();
            fn();
        }
    };

    BeforeRefresh() {
        if (this.TabPage.IsDirty() && (this.SaveAllowed == null || this.SaveAllowed())) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, this._saveMessage, "question");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    $.when(this.CompleteCheck()).then((completeResult) => {
                        if (completeResult == true) {
                            this.Save().done(() => {
                                this.PerformRefresh();
                            });
                        }
                    });
                } else if (result === false) {
                    this.PerformRefresh();;
                }
            });
        }
        else {
            this.PerformRefresh();
        }
    };

    BeforeDelete = (): boolean => {
        var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                this.Delete().then(() => { this.Parent.RefreshSchedule(); });
                this.dialog.Close();
                return true;
            }
        });
        return false;
    };

    DeleteDialogRemove = (): boolean => {
        var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                return true;
            }
        });
        return false;
    };

    PerformRefresh(): JQueryPromise<boolean> {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();
        Bao.post("Holiday/Get", JSON.stringify({ id: this.TicketId() })).then((result) => {

            this.TabPage.ObjectId(result.TicketId);

            ko.map.fromJS(result, this);
            this.TabPage.DirtyFlag.reset();
            BaoMenu.permissionEnable({ ActionKey: "HolidayDelete", Enabled: !this.IsReadonly(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: "HolidaySave", Enabled: !this.IsReadonly(), Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({
                ActionKey: "ActionHolidayApprove", Enabled: !this.IsReadonly() && this.ApprovalAllowed() && (this.TicketApproveStateId() == null || this.TicketApproveStateId() == this.TicketApproveStateUnedited()), Context: this.TabPage.Context()
            });
            BaoMenu.permissionEnable({ ActionKey: "ActionHolidayReOpen", Enabled: this.TicketStatusId() == this.TicketStatusClosed() && !this.TicketLocked(), Context: this.TabPage.Context() });
            def.resolve();
            this.TabPage.IsLoading(false);
        });

        return def.promise();
    };

    MinimizeEntity() {
        var model = ko.map.toJS(this);
        delete model.HolidayDays;

        return model;
    };

    /**
     * If page is initialized with personid, set the models-personid and get personname
     */
    InitParamPersonId(personId) {
        if (personId == null) {
            return;
        }
        // set id
        this.AffectedPersonId(personId);
        // get and set clear name for personId
        return Bao.post("Search/SearchItems", JSON.stringify({
            customFilter: [{ Key: "ConfigurationItemId", Value: personId }],
            searchKey: "PersonInternal",
            pageIndex: 0,
            pageSize: 0
        })).done((serverSearchResult) => {
            if (serverSearchResult.Models && serverSearchResult.Models.length > 0) {
                this.AffectedPersonName(serverSearchResult.Models[0].FullName);
            }
        });

    }

    InitSetValuesFromUrlParams(urlParams: { date, personId }) {
        if (!urlParams) {
            return;
        }
        if (urlParams.date) {
            this.FromDateJs(urlParams.date);
        }
        return $.when(
            this.InitParamPersonId(urlParams.personId)
        );
    }

    GetUrlParams() {

        let personId = BaoRouter.getRouteValue("PersonId", this.TabPage);
        let date = BaoRouter.getRouteValue("Date", this.TabPage);

        return {
            personId,
            date
        };
    }

    init() {
        //Bao.post(Holiday/Get)

        let urlParams = this.GetUrlParams();
        


        // first get url params befor super.init() overwrites them
        return super.init()
            .then(() => { return this.loadMetaData() })
            // set default values from Url
            .then(() => { return this.InitSetValuesFromUrlParams(urlParams); });

    }

    //init Dialog Menu
    Dialog(id?: string, date?: any, defaultDateTrue?: boolean, TicketExists?: any): JQueryPromise<boolean> {
        //this.getHolidayCollection(this);

        return Bao.post(("Holiday/Get"), JSON.stringify({
            id: id
        }), (model) => {
            ko.map.fromJS(model, this);
            if (!TicketExists) {
                this.InitParamPersonId(id);
            }
            //get affected Person
            this.FromDateJs();  //get default day
            this.ToDateJs();
            if (defaultDateTrue) {
                this.FromDateJs(date);  //get default day
                this.ToDateJs(date);
            }
            this.dialog = new BaoDialog(Bao.Session.GetMessage("msgAbsence")); //set dialog title
            this.dialog.Width("750px");
            this.loadMetaData();
            this.dialog.Buttons([
                {
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: () => { //OK button                      
                        this.CompleteCheck().then((boolCheck) => {
                            if (boolCheck) {
                                //If Check is completed and true create new Absence
                                this.Save().then(() => {
                                    this.Parent.RefreshSchedule();
                                });
                                this.dialog.Close();
                            }
                        })
                    },
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(false),
                    Focus: () => { },
                },
                {
                    Title: Bao.Session.GetMessage("msgApproveReject"),
                    Click: () => { this.OnApproveButtonClick(); },
                    Enabled: ko.observable(this.CanUseApproveButton()),
                    IsDefault: ko.observable(false),
                    Focus: () => { },
                },
                {
                    Title: Bao.Session.GetMessage("msgRemove"),
                    Click: () => { this.RemoveIsClicked(); },
                    Enabled: ko.observable(!this.IsNew()),
                    IsDefault: ko.observable(false),
                    Focus: () => { },
                },
                {
                    Title: Bao.Session.GetMessage("msgCancel"),                     //close Dialog
                    Click: () => { this.dialog.Close(); },                          //abort button
                    Enabled: ko.observable(true),
                    IsDefault: ko.observable(false),
                    Focus: () => { },
                },

            ]);
            return Bao.post("ShiftSchedule/GetShiftAbsenceDialogTemplate").done(result => {
                JSON.stringify({
                })
                //let vm = new ShiftAbsenceDialogViewModel(this);
                //vm.IsLoading = this.IsLoading;
                this.dialog.ViewModel(this);
                //dialog.Template("ShiftAbsenceDialog")
                this.dialog.Template(result.Message);
                this.InitInProgress = false;
                this.Parent.TabPage.IsLoading(false);
                this.dialog.Open();
                return this.CalculateHolidayDays();
            })
        }).then(() => {
            return $.Deferred<boolean>().resolve(Boolean(this.dialog.DialogResult())).promise();
        }).always(() => {
            this.TabPage.IsLoading(false);
        })
    }

    loadMetaData() {
        return Bao.post("Holiday/GetHolidayHideIsSubstituteClarifiedSystemSetting", (value) => {
            this.HolidayHideIsSubstituteClarified(value);
        });
    }

    PrimaryKey = "TicketId";
    RefreshUrl = "Holiday/Get";
    SaveUrl = "Holiday/Save";
    DeleteUrl = "Holiday/Delete";
    IsInUseUrl = "Holiday/IsInUse";

    PermissionForward = "HolidayMoveForwardSearch";
    PermissionBackward = "HolidayMoveBackwardSearch";
    PermissionSave = "HolidaySave";
    PermissionRefresh = "HolidayRefresh";
    PermissionDelete = "HolidayDelete";
}



export default ShiftAbsenceDialog;